import { AnswerType, ICategory } from "../models";

export const round3: ICategory[] = [
	{
		id: "1qxjdh4k1s9ik45",
		name: "Doctor Who",
		answers: [
			{
				id: "1qxjdh4k1s9ik4a",
				type: AnswerType.TEXT,
				answer: "Because he left the brakes on...",
				question: "The Tardis wheezes and groans upon landing.",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4f",
				type: AnswerType.TEXT,
				answer: "Because it has a broken chameleon circuit...",
				question: "The Tardis is stuck as a Police Phone Box",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4k",
				type: AnswerType.TEXT,
				answer: "The anagram used in 2005 when the show was revived...",
				question: "What is Torchwood",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4p",
				type: AnswerType.TEXT,
				answer: "First used by the second doctor...",
				question: "What is Sonic Screwdriver",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4u",
				type: AnswerType.TEXT,
				answer:
					"In which episode did both Peter Capaldi and Karen Gillan appear as guest stars before being cast as the 12th Doctor and Amy Pond?",
				question: "What is The Fires Pompaii",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjdh4k1s9ik46",
		name: "Super Heroes",
		answers: [
			{
				id: "1qxjdh4k1s9ik4b",
				type: AnswerType.TEXT,
				answer: "He created Spider-Man...",
				question: "Who is Stan Lee",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4g",
				type: AnswerType.TEXT,
				answer: "The year was Batman introduced...",
				question: "What is 1939?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4l",
				type: AnswerType.TEXT,
				answer: "The creators of the original superhero...",
				question: "Who is Joe Shuster and Jerry Siegel",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4q",
				type: AnswerType.TEXT,
				answer: "After the death of Steve Rogers this man took up the mantel of Captain America",
				question: "Who is Bucky Barns",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4v",
				type: AnswerType.TEXT,
				answer: "The only person that Batman reputedly ever killed...",
				question: "Who is the Joker",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjdh4k1s9ik47",
		name: "Star Trek",
		answers: [
			{
				id: "1qxjdh4k1s9ik4c",
				type: AnswerType.TEXT,
				answer: "An alter ego for professor Xavier?",
				question: "Who is Jean Luc Picard",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4h",
				type: AnswerType.TEXT,
				answer: "The only person to play himself on the show",
				question: "Who is Stephen Hawking ",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4m",
				type: AnswerType.TEXT,
				answer: "The power source for a romulan warp core...",
				question: "What is an artificial blackhole.",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4r",
				type: AnswerType.TEXT,
				answer: "She's dead, but it didn't happen how we all thought.",
				question: "Who is Tasha Yar",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4w",
				type: AnswerType.TEXT,
				answer: 'He said "The fear of death is what keeps us alive."',
				question: "Who is Dr. Mccoy",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjdh4k1s9ik48",
		name: "Hobbit Stuff",
		answers: [
			{
				id: "1qxjdh4k1s9ik4d",
				type: AnswerType.TEXT,
				answer: "The name Bilbo went by when talking to the dragon...",
				question: "What is Barelridder",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4i",
				type: AnswerType.TEXT,
				answer: 'He said "One does not simply walk into Mordor"',
				question: "Who is Boromir ",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4n",
				type: AnswerType.TEXT,
				answer: "He's not a hobbit but he often went without shoes...",
				question: "Who is Peter Jackson",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4s",
				type: AnswerType.TEXT,
				answer: "In the movie Sam was given rope from Galadriel, but in the books he given...",
				question:
					"What is Sam's garden box. It contained dirt from Galadriel's orchard and a Mallorn seed.",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4x",
				type: AnswerType.TEXT,
				answer: '"Ive quite forgotten their names"',
				question: "Who is Alatar and Pallando. (They are Maiar of the Vala Orome)",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjdh4k1s9ik49",
		name: "Star Wars",
		answers: [
			{
				id: "1qxjdh4k1s9ik4e",
				type: AnswerType.TEXT,
				answer: "He shot first.",
				question: "who is Han Solo",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4j",
				type: AnswerType.TEXT,
				answer: "So far he has appeared in every movie.",
				question: "Who is R2-D2",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4o",
				type: AnswerType.TEXT,
				answer: "This man threaten to ruin the saga...",
				question: "Who is Jar-Jar Binks",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4t",
				type: AnswerType.TEXT,
				answer: "Luke Skywalker's alter ego...",
				question: "Who is the Joker",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjdh4k1s9ik4y",
				type: AnswerType.TEXT,
				answer: "May 21st, 1980",
				question: "What is the release date of The Empire Strikes Back",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	}
];
